import { render, staticRenderFns } from "./FieldCard.vue?vue&type=template&id=c31f4cc4&"
import script from "./FieldCard.vue?vue&type=script&lang=js&"
export * from "./FieldCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports